import { connectCustom } from "@client/lib/misc";

import { globals } from "@client/globals";
import { type AppState } from "@client/types";
import appInfo from "@common/appInfo";
import Component, { type LoginProps } from "./component";

const mapStateToProps = (state: AppState): LoginProps => {
  return {
    loginPageId: appInfo.user ? undefined : globals.siteInfo.loginPageId,
    logoutUrl: appInfo.user ? globals.siteInfo.logoutUrl : undefined
  };
};

export default connectCustom(mapStateToProps)(Component);
